
import React from 'react'

function ContextItem({text,icon,callback,style}) {
  return (
    <p className={`text-sm px-2 py-1 flex gap-1 items-center cursor-pointer hover:bg-[#f1f5f9] ${style}`} onClick={callback}><span>{icon}</span>{text}</p>
  )
}

export default ContextItem